import type { JSTAccountStatusRecord } from "../../turbo-spec/NativeJSTAccountStatus";

export function getJSTAccountStatus(): JSTAccountStatusRecord | null {
  try {
    return {
      isLoggedIn: globalThis._tareData.isLoggedIn,
      id: globalThis._tareData.id,
      accountId: globalThis._tareData.accountId,
      emailAddress: globalThis._tareData.emailAddress,
      isConfirmed: globalThis._tareData.isConfirmed,
      creationDate: globalThis._tareData.creationDate,
    };
  } catch (error: unknown) {
    console.error(error);
    return null;
  }
}
